// extracted by mini-css-extract-plugin
export var border = "_12-8";
export var brand = "_12-t";
export var button = "_12-l";
export var center = "_12-a";
export var centered = "_12-6";
export var closeButton = "_12-c";
export var disabledWrapper = "_12-m";
export var error = "_12-p";
export var extraLarge = "_12-4";
export var extraSmall = "_12-1";
export var fill = "_12-i";
export var footer = "_12-h";
export var footerAction = "_12-j";
export var footerButtons = "_12-k";
export var header = "_12-7";
export var headerWithClose = "_12-d";
export var icon = "_12-o";
export var info = "_12-s";
export var inline = "_12-9";
export var large = "_12-3";
export var main = "_12-e";
export var modal = "_12-0";
export var nearFull = "_12-5";
export var neutral = "_12-u";
export var noPadding = "_12-g";
export var none = "_12-v";
export var scrollable = "_12-f";
export var small = "_12-2";
export var success = "_12-r";
export var tight = "_12-n";
export var titleIcon = "_12-b";
export var warn = "_12-q";